import { BehaviorSubject } from 'rxjs';

import { debounce } from '../utils/lodashUtils';

export default class TemplatesBloc {
  isLoading$ = new BehaviorSubject(false);
  isTagsLoading$ = new BehaviorSubject(false);

  templates$ = new BehaviorSubject([]);
  currentPage$ = new BehaviorSubject(1);
  totalData$ = new BehaviorSubject(1);

  debounceFn = {
    getTags: null,
    getTemplates: null,
  };

  constructor({ templateRepository, authRepository, userRepository, errorRepository }) {
    this.templateRepository = templateRepository;
    this.authRepository = authRepository;
    this.userRepository = userRepository;
    this.errorRepository = errorRepository;

    this.debounceFn = {
      getTags: null,
      getTemplates: null,
    };

    this.getTemplates({ limit: 15, page: 1 });
    this.getTags();
  }

  dispose() {
    this.debounceFn = {
      getTags: null,
      getTemplates: null,
    };
  }

  get tags$() {
    return this.templateRepository.tags$;
  }

  get userWorkspace$() {
    return this.authRepository.userWorkspace$;
  }

  get userDetails$() {
    return this.userRepository.userDetails$;
  }

  getTags() {
    if (this.debounceFn.getTags) {
      this.debounceFn.getTags.cancel();
    }

    this.isTagsLoading$.next(true);
    this.debounceFn.getTags = debounce(async () => {
      try {
        await this.templateRepository.getTags();
      } finally {
        this.isTagsLoading$.next(false);
      }
    }, 500);

    this.debounceFn.getTags();
  }

  getTemplates(payload) {
    if (this.debounceFn.getTemplates) {
      this.debounceFn.getTemplates.cancel();
    }

    this.isLoading$.next(true);
    this.debounceFn.getTemplates = debounce(async () => {
      try {
        const response = await this.templateRepository.getTemplates(payload);

        this.templates$.next(response?.data);
        this.currentPage$.next(response?.page);
        this.totalData$.next(response?.total || 0);
      } finally {
        this.isLoading$.next(false);
      }
    }, 500);

    this.debounceFn.getTemplates();
  }
}
